var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign__container"},[_c('span',[_vm._v(_vm._s(_vm.PRO_USER_TEXT))]),_c('IconStar',{staticClass:"icon color-8 is-xsmall"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }